import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import Cross from 'aquilla/icons/misc/Cross';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogHeading
} from 'aquilla/core/molecules/Dialog';
import HallOfFameDialogContent from './HallOfFameDialogContent';

const StyDialog = styled(Dialog)`
  height: 640px;
  ${mediaQuery.uptoMobile} {
    max-height: 100%;
    height: 100%;
    padding-top: 81px;
    margin-bottom: 155px;
  }
`;

const StyDialogHeader = styled(DialogHeader)`
  padding-bottom: ${Spacings.SPACING_4B};
  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_2B}
      ${Spacings.SPACING_4B};
  }
`;

const DialogContainer = styled.div``;

const StyDialogContent = styled(DialogContent)`
  padding: ${Spacings.SPACING_0B};
  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_0B} ${Spacings.SPACING_2B}
      ${Spacings.SPACING_0B};
  }
`;

const HallOfFameDialog = ({ openDialog, setOpenDialog, hallOfFameData }) => {
  const closeDialog = () => {
    setOpenDialog(false);
    document.body.style.overflow = 'unset';
  };
  return (
    <StyDialog open={openDialog} size="medium" close={closeDialog}>
      <StyDialogHeader>
        <Cross onClick={closeDialog} height={24} width={24} />
        <DialogHeading>Referral hall of fame</DialogHeading>
      </StyDialogHeader>
      <StyDialogContent>
        <DialogContainer>
          <HallOfFameDialogContent hallOfFameData={hallOfFameData} />
        </DialogContainer>
      </StyDialogContent>
    </StyDialog>
  );
};

export default HallOfFameDialog;
